export default __webpack_public_path__ + "static/media/erdf.17b6fd8a.png";